module.exports = __webpack_public_path__ + "media/images/sns/x_icon_white-1092570c039452d90551d328e0652bc9.png";